/*
 smartMenu - jquery Plugin,
 make the Menu auto hiding when scrolling down, and reveal it when scrolling up.
 makes an effect of revealing and hiding..
 tested on ie10, firefox and chrome.

 Base on http://jsfiddle.net/mariusc23/s6mLJ/31/

 example:
 $('.menu').smartMenu();

 Author:Yuri Ritvin

 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as anonymous module.
    define(['jquery'], factory);
  } else {
    // Browser globals.
    factory(jQuery);
  }
})(function($) {
  $.fn.smartMenu = function() {
    this.each(function() {
      var elm = $(this);
      var didScroll;
      var lastScrollTop = 0;
      var delta = 50;
      var navbarHeight = elm.outerHeight();

      $(window).scroll(function(event) {
        didScroll = true;
      });

      setInterval(function() {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 250);

      function hasScrolled() {
        var st = $(window).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
          // Scroll Down
          elm
            .removeClass('nav-down')
            .addClass('nav-up')
            .css({ top: '-' + navbarHeight + 'px' });
        } else {
          // Scroll Up
          if (st + $(window).height() < $(document).height()) {
            elm
              .removeClass('nav-up')
              .addClass('nav-down')
              .css({ top: 0 });
          }
        }

        lastScrollTop = st;
      }

      return this;
    });
  };
});
